import React from 'react';
import { ArrowRight } from 'lucide-react';

/**
 * CommandCenterHero — top-of-page welcome banner with:
 *   - Eyebrow (COMMAND CENTER)
 *   - Personalized title
 *   - Explainer copy
 *   - One primary CTA that jumps to the user's most-likely next step
 *   - Stewie mascot avatar (uses the existing /stewie_front.png)
 */
export default function CommandCenterHero({ user, primaryTool, onPrimaryAction }) {
  const firstName = (user?.name || user?.email || '').split(/[\s@]/)[0] || 'Steward';

  return (
    <section className="cc-hero" data-testid="cc-hero">
      <div className="cc-hero-content">
        <div className="cc-hero-eyebrow" data-testid="cc-hero-eyebrow">Command Center</div>
        <h1 className="cc-hero-title" data-testid="cc-hero-title">
          What do you need help with today,{' '}
          <span className="cc-hero-title-name">{firstName}?</span>
        </h1>
        <p className="cc-hero-sub">
          Choose a tool below to understand your rights, prepare your case, document what
          happened, or decide what to do next.
        </p>
        {primaryTool && (
          <button
            type="button"
            className="cc-hero-cta"
            onClick={() => onPrimaryAction?.(primaryTool)}
            data-testid="cc-hero-primary-cta"
          >
            {primaryTool.actionLabel}
            <ArrowRight size={16} strokeWidth={2.5} />
          </button>
        )}
      </div>
      <div className="cc-hero-avatar" aria-hidden="true">
        <img src="/stewie_front.png" alt="" />
      </div>
    </section>
  );
}
